import { Box, withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const WrapperBox = withStyles(({ palette, spacing }) => ({
  root: {
    padding: spacing(3.5),
    marginTop: spacing(10),
    backgroundColor: palette.common.white,
    borderRadius: spacing(1),
    textAlign: 'center',
  },
}))(Box);

export const Paragraph = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsBodySmall);
